import { Fragment } from 'react'
import { NavLink } from 'react-router-dom'

const officeData = [
  {
    title: 'Tokyo Office',
    company: 'Bekind Labs LLC',
    address: ['13-7, Hachiyama-cho,', 'Shibuya-ku, Tokyo,', 'Japan, 150-0035'],
  },
  {
    title: 'Seoul Office',
    company: 'Bekind Labs Korea LLC',
    address: ['602 Yeongdong-daero', 'Gangnam-gu, Seoul', 'Republic of Korea, 06083'],
  },
  {
    title: 'Contact Us',
    email: 'trackerboot@bekindlabs.com',
    address: [],
  },
]

const LandingFooter = () => {
  return (
    <footer
      className="flex flex-col items-center gap-[30px] pt-[60px] pb-20 bg-[#283139] w-full"
      aria-label="landing-footer"
    >
      <div className="flex flex-wrap justify-center gap-8 pb-10">
        {officeData.map((office) => (
          <div key={office.title} className="w-[230px] bg-transparent border-none">
            <div className="flex flex-col items-center gap-5 p-0">
              <h2 className="font-bold text-white text-2xl leading-9 [font-family:'Pretendard-Bold',Helvetica]">
                {office.title}
              </h2>
              {office.email ? (
                <a
                  href={`mailto:${office.email}`}
                  className="text-white text-xs leading-[18px] underline text-center [font-family:'Pretendard-Regular',Helvetica]"
                >
                  {office.email}
                </a>
              ) : (
                <address className="text-white text-xs leading-[18px] text-center not-italic [font-family:'Pretendard-Regular',Helvetica]">
                  {office.company}
                  <br />
                  {office.address.map((line) => (
                    <Fragment key={line}>
                      {line}
                      <br />
                    </Fragment>
                  ))}
                </address>
              )}
            </div>
          </div>
        ))}
      </div>

      <nav className="flex flex-wrap items-center justify-center gap-8">
        <NavLink
          className="text-white text-xs leading-6 underline [font-family:'Pretendard-Regular',Helvetica]"
          to="/policies/terms-of-use"
        >
          Terms of Use
        </NavLink>
        <NavLink
          className="text-white text-xs leading-6 underline [font-family:'Pretendard-Regular',Helvetica]"
          to="/policies/trackerboot-agreement"
        >
          Terms of Service
        </NavLink>
        <NavLink
          className="text-white text-xs leading-6 underline [font-family:'Pretendard-Regular',Helvetica]"
          to="/policies/data-processing-addendum"
        >
          Data Processing Addendum
        </NavLink>
        <NavLink
          className="text-white text-xs leading-6 underline [font-family:'Pretendard-Regular',Helvetica]"
          to="/policies/privacy-policy"
        >
          Privacy Policy
        </NavLink>
        <NavLink
          className="text-white text-xs leading-6 underline [font-family:'Pretendard-Regular',Helvetica]"
          to="/policies/cookie-policy"
        >
          Cookie Policy
        </NavLink>
      </nav>
      <div className="text-white text-xs leading-6 text-center [font-family:'Pretendard-Regular',Helvetica]">
        13-7, Hachiyama-cho, Shibuya-ku, Tokyo, Japan, 150-0035
        <br />ⓒ Bekind Labs LLC.
      </div>
    </footer>
  )
}

export default LandingFooter
